import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuthImage({ path, alt = "", className = "", testid, width }) {
  const [src, setSrc] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!path) return;
    let revoke;
    let cancelled = false;
    setFailed(false);
    (async () => {
      try {
        const suffix = width ? `?w=${width}` : "";
        const res = await api.get(`/files/${path}${suffix}`, { responseType: "blob" });
        if (cancelled) return;
        const url = URL.createObjectURL(res.data);
        revoke = url;
        setSrc(url);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path, width]);

  if (failed) {
    return (
      <div
        data-testid={testid}
        className={`flex items-center justify-center bg-zinc-100 text-[9px] font-mono uppercase tracking-[0.15em] text-zinc-400 ${className}`}
      >
        gagal dimuat
      </div>
    );
  }

  if (!src) {
    return (
      <div
        data-testid={testid}
        className={`bg-zinc-100 animate-pulse ${className}`}
      />
    );
  }
  return <img data-testid={testid} src={src} alt={alt} className={className} />;
}
